<template>
  <card class="dashboard-item">
    <!-- Card Header -->
    <template slot="header" v-if="dashboardItem.title">
      <h5 class="modal-title">{{dashboardItem.title}}</h5>
    </template>

    <i v-if="canEdit" class="fa fa-arrows-alt float-right handle"></i>
    
    <!-- Card Content -->
    <div id="chart-box" style="height: 100%">
      <bar-chart      v-if="dashboardItem.item_type == 'bar_chart'"      :height="220" :chart-data="chartData"/>
      <line-chart     v-if="dashboardItem.item_type == 'line_chart'"     :height="220" :chart-data="chartData"/>
      <doughnut-chart v-if="dashboardItem.item_type == 'doughnut_chart'" :height="200" :chart-data="chartData"/>
      <pie-chart      v-if="dashboardItem.item_type == 'pie_chart'"      :height="200" :chart-data="chartData"/>
    </div>
  </card>
</template>

<script>

// title
// text
const CHART_COLORS = ['#11cdef','#5603ad','#f5365c','#8965e0','#ffd600','#2bffc6','#fb6340','#f3a4b5','#5e72e4','#2dce89']
export default {
  components: {
    LineChart: () => import('@/components/Charts/LineChart'),
    BarChart: () => import('@/components/Charts/BarChart'),
    DoughnutChart: () => import('@/components/Charts/DoughnutChart'),
    PieChart: () => import('@/components/Charts/PieChart'),
  },
  props: {
    dashboardItem: {
      type: Object,
      required: true,
    },
    disabledActions: false,
  },
  data() {
    return {
      canEdit: false,
    }
  },
  computed: {
    chartData() {
      var datasets = []
      console.log('data:', this.dashboardItem.data)
      var labels = ' '

      if(!this.dashboardItem.data) return this.defaultData

      Object.keys(this.dashboardItem.data).forEach((key, index) => {
        console.log('key:', key, 'index:', index)
        console.log('----', typeof(this.dashboardItem.data[key]), this.dashboardItem.data[key])
        if(index == 0 && typeof(this.dashboardItem.data[key]) == 'object'){
          labels = Object.keys(this.dashboardItem.data[key]).map(v => (v || 'Não definido'))
        }

        datasets.push({
          label: key,
          backgroundColor: CHART_COLORS[index % CHART_COLORS.length],
          data:  typeof(this.dashboardItem.data[key][0]) == 'number' ? parseFloat(this.dashboardItem.data[key]) : Object.values(this.dashboardItem.data[key]).map(v => parseFloat(v || 0))
        })
      })
      console.log('datasets: ', datasets)
      console.log('labels: ', labels)

      return {
        datasets: datasets,
        labels: labels
      }
    },
    defaultData(){
      return {
        datasets: [
          {
            label: 'Demonstração 1',
            backgroundColor: CHART_COLORS[0],
            data: [10, 30, 45, 20, 80],
          },
          {
            label: 'Demonstração 2',
            backgroundColor: CHART_COLORS[1],
            data: [8, 27, 40, 25, 75],
          }
        ],
        labels: ['1', '2', '3', '4', '5'],
      }
    },
    chartHeight() {
      console.log('this.$refs', this.$refs)
      return this.$refs.chartBox.clientHeight
    },
  },
  mounted() {
    this.canEdit = !this.disabledActions && this.$can('update', 'dashboard_item')
  }
}
</script>

<style lang="scss" scoped>
  .dashboard-item {
    height: 100%;
    margin: 0px !important;

    .handle {
      position: absolute;
      right: 15px;
      top: 23px;
    }
  }

</style>
